import {Fragment} from "react";
import TopBar from "../TopBar";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Methodology from "../Methodology";
import Features from "../Features";
import Description from "../Description";

const MethodologyPage = () =>{
    return (
        <Fragment>
            <TopBar></TopBar>
            <Navbar></Navbar>
            <Features></Features>
            {/*<Description></Description>*/}
            <Methodology></Methodology>
            <Footer></Footer>
        </Fragment>
    )
}

export default MethodologyPage;